$.widget("luvit.luvitdialog", {
    options: {
        title: "",
        autoOpen: false,
        modal: true,
        width: 300,
        height: 500
    },

    _create: function () {
        
        this.element.addClass("luvitdialog");
        var dialog = this;
        if (this.autoOpen)
            this.element.show();
        else
            this.element.hide();

        this.element.prepend('<h2 class="row flex-space-b"><span class="page-header" id="Title">' + this.options.title + '</span><span id="BtnClose" class="icon-close-large"></span></h2>');
        this.element.find("#BtnClose").click(function () {            
            dialog.close();
        });
        this.element.css("width", this.options.width);
        this.element.css("height", this.options.height);

        
    },

    _setOption: function (key, value) {        
        this.options[key] = value;
        this._update();
    },

    _update: function() {
        var title = this.options.title;
        
        this.element.find("#Title").text(title);
        this.element.css("width", this.options.width);
        this.element.css("height", this.options.height);
    },

    open: function () {
        
        if (this.options.modal) {
            //$("body").append('<div class="luvitdialog-overlay"> </div>');
            luvit.getLuvitTopPage().$("body").append('<div class="luvitdialog-overlay"> </div>');
            luvit.getLuvitTopPage().$(".content-edu").css("z-index",1000);
        }
        
        var mqMobile = window.matchMedia("(max-width:600px)");        
        var top = 50;

        if (!mqMobile.matches) {
            top = $("body").scrollTop() - this.options.height;

            if (top < 0)
                top = 100;
        }
        

        
        this.element.css("top", top);
        this.element.show();        
    },

    close: function () {
        this.element.hide();
        $("body").find(".luvitdialog-overlay").remove();
        luvit.getLuvitTopPage().$("body").find(".luvitdialog-overlay").remove();
        luvit.getLuvitTopPage().$(".content-edu").css("z-index","");
    }

});